module.exports = __webpack_public_path__ + "static/media/sign-in-logo.1355d2ab.svg";